// removed by extract-text-webpack-plugin
module.exports = {"container":"_1BpcQ"};


//////////////////
// WEBPACK FOOTER
// ./app/components/loader-box/loader-box.scss
// module id = 964
// module chunks = 0 3 4 5 6